module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-policy"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'bottom'
    }
  }, [_c('PageButtons', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "itemUpdated": function($event) {
        return _vm.$emit('itemUpdated')
      }
    }
  })], 1)], 1), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Title")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.title))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Slug")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.slug))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Action")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.action))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Created")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.created_at))])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a9d1ef4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Page.vue
// module id = 2467
// module chunks = 1